import { createListenerMiddleware } from '@reduxjs/toolkit';

import { packRosterRequest } from '@modules/advancement/packRoster/duck/actions';
import { rosterApi } from '@modules/roster/api';

const rosterListenerMiddleware = createListenerMiddleware();

rosterListenerMiddleware.startListening({
  matcher: rosterApi.endpoints.getUnitRosterYouths.matchFulfilled,
  effect: async (action, listenerApi) => {
    // After unit roster is fetched, dispatch packRosterRequest return current data.
    // TODO: Remove after roster switch from selectors to RTK hooks in Rooster tab.
    listenerApi.dispatch(packRosterRequest({ forceRefetch: false }));
  },
});

export default rosterListenerMiddleware;
